import React, { useEffect, useState } from "react";
import { employeeService } from "api";
import moment from "moment";
import { Button, Col, Row, Space } from "antd";
import { formatToCurrencyType } from "helper/common";
import { FORMAT_TIME } from "types/enums";
import RenderTemplate from "components/common/DocxTemplate/RenderTemplate";
import { Notification } from "components/common";

interface FormTempaltesProps {
  hdId: string | number;
  closeModal?: () => void;
}
export default function FormTemplates({
  hdId,
  closeModal,
}: FormTempaltesProps) {
  const [thoaThuanDaoTao, setThoaThuanDaoTao] = useState([]);
  const [error, setError] = useState(false);
  const [fetchDataOnLabelClick, setFetchDataOnLabelClick] = useState(false);
  useEffect(() => {
    if (hdId && fetchDataOnLabelClick) {
      getDataThoaThuanDaoTao();
      setFetchDataOnLabelClick(false); // Reset biến fetchDataOnLabelClick để không gọi lại useEffect trong các lần render sau
    }
  }, [hdId, fetchDataOnLabelClick]);

  const handleLabelClick = () => {
    setFetchDataOnLabelClick(true); // Khi người dùng nhấn vào label, set biến fetchDataOnLabelClick thành true để gọi useEffect
  };

  const getDataThoaThuanDaoTao = async () => {
   // setError(true);
    const res = await employeeService.getTemplateThoaThuanDaoTao(
      hdId as string | number
    );

    if (res.data.code === "404") {
      Notification("warning", res.data.message);
    //  setError(false);
    } else {
      const dataList: Array<any> = res.data.data?.ds_nhan_vien || [];
      const hopDong = res.data.data?.hop_dong || {};
      if (dataList.length) {
        const newDataList = dataList.map((nv: any) => ({
        //  ...nv,
          ...hopDong,
          phi_an_o: formatToCurrencyType(hopDong.phi_an_o),
          phi_chuong_trinh_dao_tao: formatToCurrencyType(
            hopDong.phi_chuong_trinh_dao_tao
          ),
        }));
       // console.log(newDataList);
        setThoaThuanDaoTao(newDataList);
      //  setError(false);
      }
    }
  };

  return (
    <div>
      <Row gutter={[16, 16]}>
          <div onClick={handleLabelClick}>
            <RenderTemplate
              data={thoaThuanDaoTao}
              templatePath="/files/ThoaThuanDaoTao.docx"
              outputName="Mẫu in thỏa thuận đào tạo.docx"
              label="Mẫu in thỏa thuận đào tạo"
            />
          </div>
      </Row>

      <Row justify="end" style={{ marginTop: 12 }}>
        <Col>
          <Space>
            <Button
              onClick={closeModal}
              style={{
                backgroundColor: "red",
                borderColor: "red",
                color: "white",
              }}
            >
              Đóng
            </Button>
          </Space>{" "}
        </Col>
      </Row>
    </div>
  );
}
